export function setToken(token){
    localStorage.setItem("token",token)
}

export function getToken(){
        return localStorage.getItem("token")
}

export function setUserOnCache(user){
    localStorage.setItem("__user__",user)
}
export function removeUserToCache(user){
    localStorage.removeItem("__user__")
}
export function getUserToCache(){
    let user= localStorage.getItem("__user__")
    if(user){
        return JSON.parse(user)
    }
    return null
}
export function getUserRefreshTokenToCache(){
    let user= localStorage.getItem("__user__")
    if(user){
        user=JSON.parse(user)
        return user.refreshToken
    }
    return null
}